export enum configType {
  MAPTYPE = 'maptype',
  HEADINTGUP = 'headingUp',
  MAPTYPE_ROADMAP = 'roadmap',
  MAPTYPE_HYBRID = 'hybrid'
}
